export const primaryBlue = '#017CB7'
export const colorTeal = '#359EA6'
export const colorTealLight = '#ACD7DA'
export const colorOrange = '#F26651'
export const colorMagenta = '#BF1D79'
export const colorPurple = '#6950A1'
export const colorPurpleLight = '#ebdcff'


export const fontSizeL = `6.4rem`
export const fontSizeM = `3.6rem`
export const fontSizeS= `1.6rem`
export const fontSizeXS = `1rem`

export const fontWeightXS = 100
export const fontWeightS = 200
export const fontWeightM = 300
export const fontWeightL = 400

export const ColorGreyDark = `#54575C`
export const ColorGreyLight = `#e5e5e5`
export const colorGreyLightest= `#f3f3f3`

export const gridGap = `2.5rem`

export const BoxShadow = `.5px 1px 2px 1px rgba(51,51,51,.15);`

export const bezier = `cubic-bezier(0.645, 0.045, 0.355, 1)`


export const blueRange = ["#017cb7", "#79b0da", "#c6e6ff"]
export const tealRange = ["#359EA6", "#77c5cb", "#b0edf2"]
export const purpleRange = ["#6950A1", "#aa93cf", "#ebdcff"]
export const orangeRange = ["#f26651", "#fa8f78", "#ffb5a2"]
export const greyRange = ["#54575c", "#989a9c", "#e2e2e2"]